import React from 'react';
import EditorButtonIcon from './EditorButtonIcon';
import dryEditorClass from './DryEditorClass';
import NoteColorSelector from '../components/NoteColorSelector';
import FastTooltip from '../../components/FastTooltip';
import constants from '../../constants';
const { EDITOR_COMMAND_NAME_MAP } = constants;

const EditorButton = (props) => {
  const { commandName, title = '', overrideClickEvent = null, isActive = false } = props;
  const editorButtonClasses = `editor-button${isActive ? ' active' : ''}`;
  const baseClickEvent = (event) => {
    event.preventDefault();
    dryEditorClass.execCommands([{ commandName: commandName }]);
  };
  let clickEvent = overrideClickEvent ? overrideClickEvent : baseClickEvent;

  switch (commandName) {
    case EDITOR_COMMAND_NAME_MAP.background_color:
      clickEvent = (event) => {
        event.preventDefault();
        const selectedColorOption = event.target.value;
        dryEditorClass.execCommands([
          {
            commandName: `${commandName}`,
            options: { color: selectedColorOption },
          },
        ]);
      };
      return (
        <FastTooltip title={title}>
          <button className={editorButtonClasses}>
            <span>
              <NoteColorSelector
                setColor={clickEvent}
                type={'background_color'}
              />
            </span>
          </button>
        </FastTooltip>
      );
    case EDITOR_COMMAND_NAME_MAP.font_color:
      clickEvent = (event) => {
        event.preventDefault();
        const selectedColorOption = event.target.value;
        dryEditorClass.execCommands([
          {
            commandName: `${commandName}`,
            options: { color: selectedColorOption },
          },
        ]);
      };
      return (
        <FastTooltip title={title}>
          <button className={editorButtonClasses}>
            <span>
              <NoteColorSelector setColor={clickEvent} type={'font_color'} />
            </span>
          </button>
        </FastTooltip>
      );
    case EDITOR_COMMAND_NAME_MAP.heading:
      return (
        <FastTooltip title={title}>
          <button
            className={editorButtonClasses}
            onClick={clickEvent}
          >
            <span>H1</span>
          </button>
        </FastTooltip>
      );
    default:
      return (
        <FastTooltip title={title}>
          <button
            className={editorButtonClasses}
            onClick={clickEvent}
            aria-pressed={isActive}
          >
            <EditorButtonIcon name={commandName} title={title} />
          </button>
        </FastTooltip>
      );
  }
};

export default EditorButton;
